import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useReservationLocalPaymentCancelFeeTransferLimitDays } from "./hooks/use-local-payment-cancel-fee-transfer-limit-days";

export const QuestionReservationLocalPaymentCancelFeeTransferLimitDays = () => {
	const { isEdited, hasError, localPaymentCancelFeeTransferLimitDays, onSetLocalPaymentCancelFeeTransferLimitDays } =
		useReservationLocalPaymentCancelFeeTransferLimitDays();

	const title = "キャンセル料金支払い期限";
	const guide = "支払い期限はお客様にメールで通知されます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>キャンセル日から</p>
					<InputNumberField
						value={localPaymentCancelFeeTransferLimitDays.limitDays?.value ?? undefined}
						handleInput={onSetLocalPaymentCancelFeeTransferLimitDays}
						errorMessage={localPaymentCancelFeeTransferLimitDays.limitDays?.error}
						hiddenSpinButton={false}
					/>
					<p>日以内</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionReservationLocalPaymentCancelFeeTransferLimitDays.displayName =
	"QuestionReservationLocalPaymentCancelFeeTransferLimitDays";
